<template>
  <div class="base_block">
    <div v-for="item in list" v-bind:key="item.text" class="base_item" v-bind:class="mClass(item)" @click="mClick(item)" @mouseenter="mEnterMouse(item)" @mouseleave="mLeaveMouse(item)">
      <span>{{item.text}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'select-checkBox',
  data () {
    return {
      list: this.dataList,
      resultList: []
    }
  },
  props: {
    dataList: Array,
    singleSelectMode: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  methods: {
    mClick (item) {
      // 多选 加入结果列表
      // 若有则清除结果列表里，并将其状态改为未选
      if (this.singleSelectMode) {
        // 单选
        this.singleSelect(item)
      } else {
        // 多选
        this.multiSelect(item)
      }
    },
    mEnterMouse (item) {
      item.isSelect = true
    },
    mLeaveMouse (item) {
      if (!this.resultList.contain(item)) {
        item.isSelect = false
      }
    },
    multiSelect (item) {
      // 多选
      let index = this.resultList.indexOf(item)
      if (this.resultList.contain(item)) {
        // 表示已被选择
        item.isSelect = false
        this.resultList.splice(index, 1)
      } else {
        item.isSelect = true
        this.resultList.push(item)
      }
    },
    singleSelect (item) {
      // 单选
      console.log('component contain', !this.resultList.contain(item))
      if (this.resultList.length == 0) {
        item.isSelect = true
        this.resultList.push(item)
      } else if (!this.resultList.contain(item)) {
        this.resultList[0].isSelect = false
        this.resultList = []
        item.isSelect = true
        this.resultList.push(item)
      }
    }
  },
  computed: {
    mClass () {
      return function (item) {
        if (item.isSelect == null) {
          return 'content_unselect'
        }
        if (item.isSelect) {
          return 'content_select'
        } else {
          return 'content_money_unselect'
        }
      }
    }
  }
}
</script>

<style lang="scss">
  $space-between: 10px;
  $block-between: 20px;
  .content_unselect{
    border: 1px solid transparent;
    background-color: rgb(239,202,203);
    border-radius: 50px;
    padding: 10px 25px;
    cursor: pointer;
  }
  .content_select{
    border: 1px solid transparent;
    background-color: rgb(224, 95, 64);
    color: white;
    border-radius: 50px;
    padding: 10px 25px;
    cursor: pointer;
  }
  .base_item {
    margin-bottom: $space-between;
    margin-right: $space-between;
  }
  .base_block {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-left: $block-between;
    margin-top: $block-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectCheckBox.vue